import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TitledTextField from '../inputs/TitledTextField';
import { PROFILE_INFO_GRID_CLASS_NAME } from '../../theme/constants/grid';

const ProfileInfoGrid = ({
  info,
  user,
  disabledEdit,
  formValues,
  setFormValues,
  setErrorMsg,
  errorMsg,
}) => (
  <Stack spacing={2}>
    {info.map(({ title, data, icon }) => (
      <Grid container key={title} className={PROFILE_INFO_GRID_CLASS_NAME}>
        <Stack direction="column" width="100%" spacing={2.5}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {icon}
            <Typography variant="h5">{title}</Typography>
          </Stack>
          <Grid container direction="row" rowGap={2}>
            {data.map((editing) => (
              <TitledTextField
                key={editing.title}
                user={user}
                disabledEdit={disabledEdit}
                formValues={formValues}
                setFormValues={setFormValues}
                setErrorMsg={setErrorMsg}
                errorMsg={errorMsg}
                totalElements={data.length}
                {...editing}
              />
            ))}
          </Grid>
        </Stack>
      </Grid>
    ))}
  </Stack>
);

ProfileInfoGrid.propTypes = {
  info: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.shape({
      })).isRequired,
      icon: PropTypes.element,
    }),
  ).isRequired,
  user: PropTypes.shape({}).isRequired,
  disabledEdit: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({}).isRequired,
  setFormValues: PropTypes.func.isRequired,
  setErrorMsg: PropTypes.func.isRequired,
  errorMsg: PropTypes.shape({}).isRequired,
};

export default ProfileInfoGrid;
